import React from 'react'
import { SelectInlineInput } from '@ztechapps/webui.input'
import { ProductTypeSelect } from './ProductTypeSelect'
import { productTypeOptions } from './productTypeOptions'

export const ProductTypeSelectInlineInput = ({ ...rest }: any) => {
  return <SelectInlineInput {...rest} selectComponent={ProductTypeSelect} selectOptions={productTypeOptions} />
}
